import * as z from "zod";

export const getFavoritesEmail = {
  name: "getFavoritesEmail" as const,
  input: z.object({}),
  output: z.string(),
};
